<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Purchase Request" active>

                                <b-row v-if="hasFailedDataPurchaseRequest">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPurchaseRequest.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseRequestsFailed" :fields="fieldsPurchaseRequest" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseRequest" :sort-desc.sync="sortDescPurchaseRequest" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(purchaseRequestDate)="row">
													{{ row.item.purchaseRequestDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPurchaseRequest.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseRequests" :fields="fieldsPurchaseRequest" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseRequest" :sort-desc.sync="sortDescPurchaseRequest" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(purchaseRequestDate)="row">
													{{ row.item.purchaseRequestDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Purchase Request Detail" active>

                                <b-row v-if="hasFailedDataPurchaseRequestDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPurchaseRequestDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseRequestDetailsFailed" :fields="fieldsPurchaseRequestDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseRequestDetail" :sort-desc.sync="sortDescPurchaseRequestDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPurchaseRequestDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="purchaseRequestDetails" :fields="fieldsPurchaseRequestDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPurchaseRequestDetail" :sort-desc.sync="sortDescPurchaseRequestDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestList from '@/models/PurchaseRequest/PurchaseRequestList';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPurchaseRequest: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Classification", key: 'partClassificationCode', sortable: false},
				{"class" : "th-status", "label" : "Vendor", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "TotalQty", key: 'totalQty', sortable: false},
				{"class" : "th-status", "label" : "Revisi", key: 'revisi', sortable: false},
				{"class" : "th-status", "label" : "Purchase Order Number", key: 'purchaseOrderNumber', sortable: false},
				{"class" : "th-status", "label" : "Purchase Request Status", key: 'purchaseRequestStatus', sortable: false},
				{"class" : "th-status", "label" : "Purchase Request Date", key: 'purchaseRequestDate', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPurchaseRequestDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			purchaseRequests : [],
			purchaseRequestsFailed: [],
			purchaseRequestId : '',
			sortByPurchaseRequest: '',
			sortDescPurchaseRequest: '',
			hasFailedDataPurchaseRequest: false,
			totalFailedPurchaseRequest: 0,
			totalSucceedPurchaseRequest: 0,
			purchaseRequestDetails : [],
			purchaseRequestDetailsFailed: [],
			purchaseRequestDetailId : '',
			sortByPurchaseRequestDetail: '',
			sortDescPurchaseRequestDetail: '',
			hasFailedDataPurchaseRequestDetail: false,
			totalFailedPurchaseRequestDetail: 0,
			totalSucceedPurchaseRequestDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('purchaserequest/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('purchaserequest/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPurchaseRequestForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPurchaseRequestForUpload : async function() {
			let _this = this;
			this.$http.get('purchaserequest/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.purchaseRequests = [];
_this.purchaseRequestDetails = [];


					if (response != null) {
						let result = response.data;
						_this.purchaseRequests = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPurchaseRequest = _this.purchaseRequests.length;

						_this.purchaseRequestsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPurchaseRequest = true;
						_this.totalFailedPurchaseRequest = 0;
						if(_this.purchaseRequestsFailed == undefined || _this.purchaseRequestsFailed.length === 0) _this.hasFailedDataPurchaseRequest = false;
						if(_this.hasFailedDataPurchaseRequest) _this.totalFailedPurchaseRequest = _this.purchaseRequestsFailed.length;
						_this.purchaseRequestDetails = [];
						_this.purchaseRequestDetailsFailed = [];
						_this.hasFailedDataPurchaseRequestDetail = true;
						_this.totalSucceedPurchaseRequestDetail = 0;
						result.forEach(function(element) {
							_this.purchaseRequestDetails.push(...element.purchaseRequestDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPurchaseRequestDetail = _this.purchaseRequestDetails.length;

							_this.purchaseRequestDetailsFailed.push(...element.purchaseRequestDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.purchaseRequestDetailsFailed == undefined || _this.purchaseRequestDetailsFailed.length === 0) _this.hasFailedDataPurchaseRequestDetail = false;
							if(_this.hasFailedDataPurchaseRequestDetail) _this.totalFailedPurchaseRequestDetail = _this.purchaseRequestDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'purchaserequest/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PurchaseRequest.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPurchaseRequest = new PurchaseRequestFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
